import { render, staticRenderFns } from "./saleCategory.vue?vue&type=template&id=5f454e30&"
import script from "./saleCategory.vue?vue&type=script&lang=js&"
export * from "./saleCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports